module.exports = __webpack_public_path__ + "img/abmb.3a959493.gif";